(function () {
  'use strict';

  if (window.__loantiLicznikPromocjiInit) {
    return;
  }
  window.__loantiLicznikPromocjiInit = true;

  function parseKoniec(value) {
    if (!value || typeof value !== 'string') {
      return NaN;
    }

    var trimmed = value.trim();
    if (!trimmed) {
      return NaN;
    }

    var parsed = Date.parse(trimmed);
    if (!isNaN(parsed)) {
      return parsed;
    }

    if (/^\d+$/.test(trimmed)) {
      var asNumber = Number(trimmed);
      if (asNumber < 1e12) {
        asNumber *= 1000;
      }
      return asNumber;
    }

    return NaN;
  }

  function padSekundy(value) {
    return value < 10 ? '0' + value : String(value);
  }

  function formatPozostalyCzas(ms, kompaktowy) {
    if (ms <= 0) {
      return null;
    }

    var totalSec = Math.floor(ms / 1000);
    var dni = Math.floor(totalSec / 86400);
    totalSec %= 86400;
    var godz = Math.floor(totalSec / 3600);
    totalSec %= 3600;
    var min = Math.floor(totalSec / 60);
    var sek = totalSec % 60;

    var czesci = [];

    if (dni > 0 || !kompaktowy) {
      czesci.push(dni + ' dni');
    }

    czesci.push(godz + ' godz.');
    czesci.push(min + ' min');
    czesci.push(padSekundy(sek) + ' sek.');

    return czesci.join(' ');
  }

  function ukryjLicznik(el) {
    el.classList.add('is-hidden');
    el.setAttribute('hidden', 'hidden');
    el.setAttribute('aria-hidden', 'true');
  }

  function aktualizujLicznik(el) {
    var koniecMs = parseKoniec(el.getAttribute('data-koniec'));
    if (isNaN(koniecMs)) {
      ukryjLicznik(el);
      return false;
    }

    var pozostalo = koniecMs - Date.now();
    var czasEl = el.querySelector('[data-licznik-czas]');
    var kompaktowy = el.getAttribute('data-wariant') === 'produkt';

    if (pozostalo <= 0) {
      ukryjLicznik(el);
      return false;
    }

    if (czasEl) {
      czasEl.textContent = formatPozostalyCzas(pozostalo, kompaktowy);
    }

    return true;
  }

  function initLicznikPromocji() {
    var liczniki = document.querySelectorAll('[data-loanti-licznik-promocji]');
    if (!liczniki.length) {
      return;
    }

    var aktywne = [];

    liczniki.forEach(function (el) {
      if (aktualizujLicznik(el)) {
        aktywne.push(el);
      }
    });

    if (!aktywne.length) {
      return;
    }

    var intervalId = window.setInterval(function () {
      aktywne = aktywne.filter(function (el) {
        return aktualizujLicznik(el);
      });

      if (!aktywne.length) {
        window.clearInterval(intervalId);
      }
    }, 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initLicznikPromocji);
  } else {
    initLicznikPromocji();
  }

  document.addEventListener('shopify:section:load', initLicznikPromocji);
})();
